import messages from './messages.js';

const schema = {
  id: 'DpoDetails',
  properties: [
    {
      id: 'name',
      label: messages.name,
      type: 'text',
      required: true,
    },
    {
      id: 'email',
      label: messages.email,
      type: 'email',
      required: true,
    },
  ],
};

export default schema;
